// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__N5Ur5","Open":"SideDrawer_Open__1411o","Close":"SideDrawer_Close__1rQJs","Logo":"SideDrawer_Logo__2_NoS"};